import { NgModule, Optional, SkipSelf, ErrorHandler } from '@angular/core';
import { LoggerService } from './logger.service';
import { AppExceptionHandler } from './app.exception.handler';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpExceptionInterceptor } from '../shared/http-exception-interceptor';
import { AuthenticationService } from './authentication.service';
import { authInitProvider } from './auth-initializer';

@NgModule({
  providers: [
    /*
      We should only put global and singleton services here
      Examples are AuthService, UserService, etc
    */
    LoggerService,
    AuthenticationService,
    authInitProvider,
    { provide: ErrorHandler, useClass: AppExceptionHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpExceptionInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  // injecting CoreModule insures that this class is only imported once (in app.module)
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error(
        'Not very smart! You should never import this module. Only imported in AppModule!'
      );
    }
  }
}
